const STORAGE_KEY = "erPlaySession";

export function saveErPlaySession(session) {
	if (!session?.gameId || !session?.groupId) return;
	try {
		localStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({
				...session,
				savedAt: Date.now(),
			})
		);
	} catch (_) {
		/* quota / private mode */
	}
}

export function loadErPlaySession() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!parsed || typeof parsed !== "object") return null;
		return parsed;
	} catch (_) {
		return null;
	}
}

export function clearErPlaySession() {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch (_) {
		/* noop */
	}
}
